const WhatMakesGreatTripForYou = Object.freeze(
  {
    CULTURE_AND_HISTORY: "culture_and_history",
    FOOD_AND_DRINK: "food_and_drink",
    NATURE_AND_WILDLIFE: "nature_and_wildlife",
    BEACHES_AND_WATER: "beaches_and_water",
    ART_AND_DESIGN: "art_and_design",
    WELLNESS: "wellness",
    NIGHTLIFE: "nightlife",
    SHOPPING_AND_MARKETS: "shopping_and_markets",
    ADVENTURE: "adventure",
    RELAXED_LEISURE: "relaxed_leisure",
    EVENTS_AND_ENTERTAINMENT: "events_and_entertainment",
    LOCAL_TRADITIONS: "local_traditions",
  } as const,
);

export type WhatMakesGreatTripForYou =
  (typeof WhatMakesGreatTripForYou)[keyof typeof WhatMakesGreatTripForYou];

export const allWhatMakesGreatTripForYou: [
  WhatMakesGreatTripForYou,
  ...WhatMakesGreatTripForYou[],
] = Object.values(WhatMakesGreatTripForYou) as [
  WhatMakesGreatTripForYou,
  ...WhatMakesGreatTripForYou[],
];

export default WhatMakesGreatTripForYou;
